import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import { useLanguage } from '../../contexts/LanguageContext';

const propTypes = {
  ...SectionSplitProps.types,
};

const defaultProps = {
  ...SectionSplitProps.defaults,
};

const prosperiaChat = {
  en: {
    header: 'Prosperia · Financial Agent',
    msgs: [
      { type: 'user', text: "What was last quarter's net income?" },
      {
        type: 'agent',
        text: (
          <>
            Q3 net income was <strong style={{ color: '#24E5AF' }}>$847,320</strong> — a 12.4%
            increase vs Q2. Want me to generate the full report?
          </>
        ),
      },
      { type: 'user', text: 'Yes, and compare it with last year.' },
    ],
    placeholder: 'Ask about financials...',
  },
  es: {
    header: 'Prosperia · Agente Financiero',
    msgs: [
      { type: 'user', text: '¿Cuál fue el ingreso neto del último trimestre?' },
      {
        type: 'agent',
        text: (
          <>
            El ingreso neto Q3 fue <strong style={{ color: '#24E5AF' }}>$847,320</strong> — un
            aumento del 12.4% vs Q2. ¿Quieres que genere el reporte completo?
          </>
        ),
      },
      { type: 'user', text: 'Sí, y compáralo con el año anterior.' },
    ],
    placeholder: 'Consultar datos financieros...',
  },
};

const ProsperiaCard = ({ lang = 'en' }) => {
  const c = prosperiaChat[lang];
  return (
    <div className="case-study-card">
      <div className="case-study-card-header">
        <div className="case-study-card-dot" style={{ background: '#ff5f57' }} />
        <div className="case-study-card-dot" style={{ background: '#febc2e' }} />
        <div className="case-study-card-dot" style={{ background: '#28c840' }} />
        <span
          style={{
            marginLeft: '12px',
            fontSize: '0.72rem',
            color: 'var(--ec-muted)',
            letterSpacing: '0.06em',
          }}
        >
          {c.header}
        </span>
      </div>
      <div className="case-study-card-body">
        {c.msgs.map((m, i) => (
          <div key={i} className={`chat-bubble ${m.type}`}>
            {m.text}
          </div>
        ))}
        <div className="chat-bubble typing" style={{ width: 60 }}>
          <div className="typing-dot" />
          <div className="typing-dot" />
          <div className="typing-dot" />
        </div>
      </div>
      <div
        style={{
          padding: '12px 20px',
          borderTop: '1px solid rgba(255,255,255,0.05)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <div
          style={{
            flex: 1,
            background: 'rgba(255,255,255,0.05)',
            borderRadius: '8px',
            padding: '8px 12px',
            fontSize: '0.75rem',
            color: 'var(--ec-muted)',
          }}
        >
          {c.placeholder}
        </div>
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            background: 'var(--ec-gradient)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.8rem',
          }}
        >
          →
        </div>
      </div>
    </div>
  );
};

const estudiosChat = {
  en: {
    header: 'Estudios Tributarios · Moodle',
    msgs: [
      { type: 'user', text: 'What are the requirements for VAT exemption?' },
      {
        type: 'agent',
        text: (
          <>
            Per Unit 4, to apply for VAT exemption you need:{' '}
            <strong style={{ color: '#24E5AF' }}>1)</strong> Declared exempt activity,{' '}
            <strong style={{ color: '#24E5AF' }}>2)</strong> Updated RUT registration...
          </>
        ),
      },
      { type: 'user', text: 'Where is that in the material?' },
      { type: 'agent', text: '📄 Module 4, page 23. Want me to explain the next concept?' },
    ],
    placeholder: 'Ask about the course...',
  },
  es: {
    header: 'Estudios Tributarios · Moodle',
    msgs: [
      { type: 'user', text: '¿Cuáles son los requisitos para la exención del IVA?' },
      {
        type: 'agent',
        text: (
          <>
            Según la Unidad 4, para aplicar la exención del IVA necesitas:{' '}
            <strong style={{ color: '#24E5AF' }}>1)</strong> Actividad exenta declarada,{' '}
            <strong style={{ color: '#24E5AF' }}>2)</strong> Registro en el RUT actualizado...
          </>
        ),
      },
      { type: 'user', text: '¿Dónde está eso en el material?' },
      {
        type: 'agent',
        text: '📄 Módulo 4, página 23. ¿Quieres que te explique el siguiente concepto?',
      },
    ],
    placeholder: 'Pregunta sobre el curso...',
  },
};

const EstudiosCard = ({ lang = 'en' }) => {
  const c = estudiosChat[lang];
  return (
    <div className="case-study-card">
      <div className="case-study-card-header">
        <div className="case-study-card-dot" style={{ background: '#ff5f57' }} />
        <div className="case-study-card-dot" style={{ background: '#febc2e' }} />
        <div className="case-study-card-dot" style={{ background: '#28c840' }} />
        <span
          style={{
            marginLeft: '12px',
            fontSize: '0.72rem',
            color: 'var(--ec-muted)',
            letterSpacing: '0.06em',
          }}
        >
          {c.header}
        </span>
      </div>
      <div className="case-study-card-body">
        {c.msgs.map((m, i) => (
          <div key={i} className={`chat-bubble ${m.type}`}>
            {m.text}
          </div>
        ))}
      </div>
      <div
        style={{
          padding: '12px 20px',
          borderTop: '1px solid rgba(255,255,255,0.05)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <div
          style={{
            flex: 1,
            background: 'rgba(255,255,255,0.05)',
            borderRadius: '8px',
            padding: '8px 12px',
            fontSize: '0.75rem',
            color: 'var(--ec-muted)',
          }}
        >
          {c.placeholder}
        </div>
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            background: 'var(--ec-gradient)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.8rem',
          }}
        >
          →
        </div>
      </div>
    </div>
  );
};

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {
  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className,
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider',
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top',
  );

  const { lang } = useLanguage();

  const content = {
    en: {
      label: 'In Production',
      title: 'See one running.\nNot a demo.',
      items: [
        {
          badge: 'Moodle Course Agent',
          title: 'Estudios Tributarios',
          url: 'https://estudiostributarios.com',
          urlLabel: 'estudiostributarios.com',
          desc: 'Estudios Tributarios runs an AI agent inside its Moodle course. Students ask on the page where they study and get answers drawn only from the course material, cited by unit and page, 24 hours a day. When a question is not in the course, the agent says so.',
          tags: ['Moodle', 'Course Material Only', 'Cited Answers', '24/7'],
        },
        {
          badge: 'Also From The Studio',
          title: 'Prosperia',
          url: 'https://prosperiaapp.com',
          urlLabel: 'prosperiaapp.com',
          desc: 'Outside education, the same studio ships agents on WhatsApp and the web. Prosperia answers finance questions for accounting professionals and their clients in plain language, and generates the full report on request.',
          tags: ['WhatsApp Bot', 'Web Chat', 'Financial Reports', 'LLM'],
        },
      ],
      visit: 'Visit site',
    },
    es: {
      label: 'En Producción',
      title: 'Míralo funcionando.\nNo es un demo.',
      items: [
        {
          badge: 'Agente en Moodle',
          title: 'Estudios Tributarios',
          url: 'https://estudiostributarios.com',
          urlLabel: 'estudiostributarios.com',
          desc: 'Estudios Tributarios tiene un agente de IA dentro de su curso en Moodle. Los alumnos preguntan en la página donde estudian y reciben respuestas tomadas solo del material del curso, citadas por unidad y página, las 24 horas. Si la pregunta no está en el curso, el agente lo dice.',
          tags: ['Moodle', 'Solo el material', 'Respuestas citadas', '24/7'],
        },
        {
          badge: 'También del estudio',
          title: 'Prosperia',
          url: 'https://prosperiaapp.com',
          urlLabel: 'prosperiaapp.com',
          desc: 'Fuera de la educación, el mismo estudio entrega agentes en WhatsApp y Web. Prosperia responde preguntas financieras a contadores y a sus clientes en lenguaje natural, y genera el reporte completo si lo piden.',
          tags: ['Bot WhatsApp', 'Chat Web', 'Reportes Financieros', 'LLM'],
        },
      ],
      visit: 'Visitar sitio',
    },
  };

  const c = content[lang];
  // Order mirrors `items`: the Moodle case study leads, Prosperia follows.
  const visuals = [<EstudiosCard key="e" lang={lang} />, <ProsperiaCard key="p" lang={lang} />];

  return (
    <section {...props} id="work" className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <div className="center-content reveal-from-bottom" style={{ marginBottom: '64px' }}>
            <span className="section-label">{c.label}</span>
            <h2
              className="mt-0 mb-0"
              style={{
                fontSize: 'clamp(1.8rem, 4vw, 3rem)',
                fontWeight: 800,
                letterSpacing: '-0.02em',
                whiteSpace: 'pre-line',
              }}
            >
              {c.title}
            </h2>
          </div>
          <div className={splitClasses}>
            {c.items.map((item, i) => (
              <div className="split-item" key={i}>
                <div
                  className="split-item-content center-content-mobile reveal-from-left"
                  data-reveal-container=".split-item"
                >
                  <span className="case-study-badge">{item.badge}</span>
                  <h3 className="mt-0 mb-12">{item.title}</h3>
                  <p className="m-0">{item.desc}</p>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '20px' }}>
                    {item.tags.map((tag, j) => (
                      <span
                        key={j}
                        style={{
                          background: 'rgba(255,255,255,0.05)',
                          border: '1px solid rgba(255,255,255,0.1)',
                          color: 'var(--ec-muted)',
                          fontSize: '0.7rem',
                          fontWeight: 600,
                          letterSpacing: '0.06em',
                          padding: '4px 10px',
                          borderRadius: '100px',
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <a
                    className="case-study-link"
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {c.visit}: {item.urlLabel}
                    <span className="case-study-link-arrow">→</span>
                  </a>
                </div>
                <div
                  className={classNames(
                    'split-item-image center-content-mobile reveal-from-bottom',
                    imageFill && 'split-item-image-fill',
                  )}
                  data-reveal-container=".split-item"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  {visuals[i]}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
